// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* TERNARY */
.em-ternary-legend-label {
    font-size: 13px;
    stroke: none;
    fill: #3a3a3a;
}
.em-ternary-grid-line,
.em-ternary-grid-line-minor {
    pointer-events: none;
}
.em-ternary-axis-title {
    font-size: 13px;
}
.em-ternary-axis-tick {
    stroke: #3a3a3a;
    stroke-width: 1;
    pointer-events: none;
}
.em-ternary-legend-data-point,
.em-ternary-discrete-polygon {
    cursor: pointer;
}
.em-ternary-discrete-polygon {
    transition: fill 150ms;
}
.em-ternary-annotation-line {
    stroke: #949494;
    stroke-width: 1;
    opacity: 1;
}
.em-ternary-center-annotation-label {
    font-size: 11px;
    fill: #4e4e4e;
    font-style: italic;
    text-anchor: end;
}
.em-ternary-center-line-label {
    opacity: 1;
    font-size: 10px;
}
.em-ternary-center-point {
    pointer-events: none;
}
`, "",{"version":3,"sources":["webpack://./src/css/legend/ternary.css"],"names":[],"mappings":"AAAA,YAAY;AACZ;IACI,eAAe;IACf,YAAY;IACZ,aAAa;AACjB;AACA;;IAEI,oBAAoB;AACxB;AACA;IACI,eAAe;AACnB;AACA;IACI,eAAe;IACf,eAAe;IACf,oBAAoB;AACxB;AACA;;IAEI,eAAe;AACnB;AACA;IACI,sBAAsB;AAC1B;AACA;IACI,eAAe;IACf,eAAe;IACf,UAAU;AACd;AACA;IACI,eAAe;IACf,aAAa;IACb,kBAAkB;IAClB,gBAAgB;AACpB;AACA;IACI,UAAU;IACV,eAAe;AACnB;AACA;IACI,oBAAoB;AACxB","sourcesContent":["/* TERNARY */\r\n.em-ternary-legend-label {\r\n    font-size: 13px;\r\n    stroke: none;\r\n    fill: #3a3a3a;\r\n}\r\n.em-ternary-grid-line,\r\n.em-ternary-grid-line-minor {\r\n    pointer-events: none;\r\n}\r\n.em-ternary-axis-title {\r\n    font-size: 13px;\r\n}\r\n.em-ternary-axis-tick {\r\n    stroke: #3a3a3a;\r\n    stroke-width: 1;\r\n    pointer-events: none;\r\n}\r\n.em-ternary-legend-data-point,\r\n.em-ternary-discrete-polygon {\r\n    cursor: pointer;\r\n}\r\n.em-ternary-discrete-polygon {\r\n    transition: fill 150ms;\r\n}\r\n.em-ternary-annotation-line {\r\n    stroke: #949494;\r\n    stroke-width: 1;\r\n    opacity: 1;\r\n}\r\n.em-ternary-center-annotation-label {\r\n    font-size: 11px;\r\n    fill: #4e4e4e;\r\n    font-style: italic;\r\n    text-anchor: end;\r\n}\r\n.em-ternary-center-line-label {\r\n    opacity: 1;\r\n    font-size: 10px;\r\n}\r\n.em-ternary-center-point {\r\n    pointer-events: none;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
